<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="720px">
      <custom-modal title="Income Details" @onClose="close" :showSave="false">
        <v-container>
          <v-row>
            <v-col cols="6"><h4>Reference number</h4></v-col>
            <v-col cols="6" class="text-right">
              <v-chip label>{{ income.reference_number || "----" }}</v-chip>
            </v-col>
            <v-col cols="6"><h4>Income for</h4></v-col>
            <v-col cols="6" class="text-right">
              <v-chip label>{{ sourceName }}</v-chip>
            </v-col>
            <v-col cols="6"><h4>Date</h4></v-col>
            <v-col cols="6" class="text-right">
              <v-chip label>{{ income.date | formatDate }}</v-chip>
            </v-col>
            <v-col cols="6"><h4>Category</h4></v-col>
            <v-col cols="6" class="text-right">
              <v-chip label>{{ (income.category && income.category.name) || "----" }}</v-chip>
            </v-col>
            <v-col cols="6"><h4>Amount</h4></v-col>
            <v-col cols="6" class="text-right">
              <v-chip label>{{ income.amount | formatCurrency }}</v-chip>
            </v-col>
            <v-col cols="12"><h4>Remark</h4></v-col>
            <v-col cols="12">{{ income.remark || "----" }}</v-col>
          </v-row>
        </v-container>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import CustomModal from "@/components/base/CustomModal";

export default {
  components: { CustomModal },
  props: {
    visible: { type: Boolean, default: false },
    income: { type: Object, default: () => ({}) },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
    sourceName() {
      if (this.income.income_for === "Shop") {
        return (this.income.shop && this.income.shop.name) || "Shop";
      }
      if (this.income.income_for === "Warehouse") {
        return (this.income.warehouse && this.income.warehouse.name) || "Warehouse";
      }
      return this.income.income_for || "----";
    },
  },
  methods: {
    close() {
      this.show = false;
    },
  },
};
</script>
